<template>
  <v-card flat tile :loading="loading">
    <v-container>
      <ContactSchool class="mb-4" outlined :person="person"></ContactSchool>
      <v-card class="mb-4" outlined>
        <v-system-bar>E-Mail</v-system-bar>
        <div class="text-right"><EmailClient /></div>
        <ListItem
          v-for="dl in dls"
          v-bind:key="dl.description"
          :align="dl.emails.length > 2 ? 'start' : 'center'"
          :title="dl.description.replace('E-Mail an', '').replace(' von', '')"
        >
          <Mailto :dl="dl.emails" :bcc="dl.bcc"
            >{{ joinEmails(dl.emails) }}
          </Mailto>
        </ListItem>
      </v-card>
      <ContactPersonal class="mb-4" outlined :person="person" />

      <PersonalChanges v-if="person" class="mb-4" outlined :id="person.id" />

      <ContactDependents
        v-if="
          person &&
          person.type &&
          (person.type.code == 'legalGuardian' || person.type.code == 'teacher')
        "
        class="mb-4"
        outlined
        :person="person"
      />
      <ContactLegalGuardians class="mb-4" outlined :person="person" />
    </v-container>
  </v-card>
</template>

<script>
import { defineComponent } from "vue";
import { saveChildRoute } from "@/router/helper";
import EmailClient from "@/components/settings/EmailClient.vue";
import Mailto from "@/components/Mailto.vue";
import ContactDependents from "./ContactDependents.vue";
import ContactSchool from "common/components/Person/ContactSchool.vue";
import ContactLegalGuardians from "common/components/Person/ContactLegalGuardians.vue";
import ContactPersonal from "common/components/Person/ContactPersonal.vue";

import ListItem from "@/components/ListItem.vue";
import PersonalChanges from "@/components/PersonalChanges.vue";
import { joinEmails } from "common/utils/helper";

export default defineComponent({
  name: "PersonContact",
  components: {
    ContactDependents,
    ContactLegalGuardians,
    ContactPersonal,
    ContactSchool,
    EmailClient,
    ListItem,
    Mailto,
    PersonalChanges,
  },
  props: {
    id: { type: String },
  },
  computed: {
    personId() {
      return Number.parseInt(this.id);
    },
  },
  data() {
    return {
      person: {},
      dls: [],
      loading: false,
    };
  },
  methods: {
    joinEmails,
    async getData() {
      if (this.personId) {
        this.loading = true;
        this.person = await this.apiGet({
          resource: "person/person",
          id: this.personId,
        });
        this.dls = await this.apiGet({
          resource: "person/email",
          id: this.personId,
        });
        this.loading = false;
      }
    },
  },
  watch: {
    async id() {
      await this.getData();
    },
  },
  async created() {
    await this.getData();
  },
  beforeRouteUpdate(to, from, next) {
    saveChildRoute(to, next);
  },
});
</script>
